module.exports = __webpack_public_path__ + "static/media/eyewearstore-top-bkg3.716cd361.jpg";